module.exports = __webpack_public_path__ + "static/media/player-nb.71a1287d.png";